'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = 'M147.2 83c2.2-3 4.3-5.7 6.1-8.2l0 0c6.3-8.6 10.7-14.5 16-19.3 5.2-4.7 10.5-7.4 19.6-7.4 10.5 0 19 8.5 19 19l0 6.1c0 8.2-6.9 24.3-28.5 46.6-16.4 16.9-36 32-51.5 42.7-15.5-10.7-35.1-25.8-51.5-42.7-21.6-22.3-28.5-38.4-28.5-46.6L48 67c0-10.5 8.5-19 19-19 9.3 0 14.6 2.7 19.7 7.4 5.2 4.7 9.4 10.4 15.5 18.8l0 0c2 2.7 4.1 5.6 6.5 8.9 4.5 6 11.6 9.6 19.2 9.6S142.7 89 147.2 83zM189 0c-22.3 0-38.7 8-51.8 19.8-3.2 2.9-6.2 6.1-9.1 9.4-2.9-3.3-5.9-6.5-9-9.3-13.1-11.8-29.6-19.8-52-19.8-37 0-67 30-67 67l0 6.1c0 56.1 75.2 112.1 110.3 135.3 10.8 7.1 24.5 7.1 35.3 0 35.1-23.1 110.3-79.2 110.3-135.3l0-6.1c0-37-30-67-67-67zM512 24c0-7.2-3.2-14-8.8-18.6s-12.9-6.4-19.9-5l-160 32C312.1 34.7 304 44.6 304 56l0 105.5c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-132.3 112-22.4 0 76.2c-5.1-1-10.5-1.5-16-1.5-35.3 0-64 21.5-64 48s28.7 48 64 48 64-21.5 64-48l0-152zM106.9 309.5l2.7-5.5 68.7 0 2.7 5.5c8.1 16.3 24.8 26.5 42.9 26.5 8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16 18.2 0 34.8-10.3 42.9-26.5zM224 288l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-88.4 0c-12.1 0-23.2 6.9-28.6 17.7L64 288c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64zM184 392a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM473.4 259.1c-6-4.4-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7s8.3 10.4 15 10.4l55.7 0-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7S502.7 368 496 368l-55.7 0 38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;